export enum MonitoringSpanEnum {
  EndUserId = 'enduser.id',
  InitialPageLoadAutomation = 'initial.page.load.automation',
  InitialPageLoadMyCompanyTickets = 'initial.page.load.mycompanytickets',
  InitialPageLoadMyCompanyCases = 'initial.page.load.mycompanycases',
  InitialPageLoadGetHelp = 'initial.page.load.gethelp',
  InitialPageLoadFullTicketDetails = 'initial.page.load.full.ticketdetails',
  InitialPageLoadFullCaseDetails = 'initial.page.load.full.casedetails',
  InitialPageLoadFullEscalationDetails = 'initial.page.load.full.escalationdetails',
  InitialPageLoadPartialTicketDetails = 'initial.page.load.partial.ticketdetails',
  InitialPageLoadPartialCaseDetails = 'initial.page.load.partial.casedetails',
  InitialPageLoadPartialEscalationDetails = 'initial.page.load.partial.escalationdetails',
  InitialPageLoadSupportSystemTicket = 'initial.page.load.service.now.ticket',
  InitialPageLoadCreateTicketForm = 'initial.page.load.createticketform',
  InitialPageLoadActiveReports = 'initial.page.load.activereports',
  InitialPageLoadActiveReport = 'initial.page.load.activereport',
  InitialPageLoadAvailableReports = 'initial.page.load.availablereports',
  InitialPageLoadReportRequests = 'initial.page.load.reportrequests',
}
